import React from 'react'
import PropTypes from 'prop-types'
import {Carousel} from '@/components/ui/carousel'
import {
    defaultPreviousButton,
    defaultNextButton,
    defaultCarouselContent,
    defaultContentNav
} from './defaultConfig'
import {cn} from '@/lib/utils'

export const CustomCarousel = (props) => {
    const {
        children,
        loop,
        slidesToScroll,
        align,
        autoplay,
        autoplayDelay,
        stopOnInteraction,
        stopOnMouseEnter,
        attributes
    } = props
    const {className, ...restAttributes} = attributes || {}
    return (
        <Carousel
            opts={{loop, slidesToScroll, align}}
            autoplay={autoplay}
            autoplayDelay={autoplayDelay}
            stopOnInteraction={stopOnInteraction}
            stopOnMouseEnter={stopOnMouseEnter}
            className={cn('mx-auto w-[80%]', className)}
            {...restAttributes}
            data-testid="carousel-Carousel"
        >
            {children}
        </Carousel>
    )
}

CustomCarousel.propTypes = {
    attributes: PropTypes.object,
    align: PropTypes.string,
    carouselButtonIcon: PropTypes.string,
    contentWidth: PropTypes.number,
    loop: PropTypes.bool,
    slidesToScroll: PropTypes.number,
    autoplay: PropTypes.bool,
    autoplayDelay: PropTypes.number,
    stopOnInteraction: PropTypes.bool,
    stopOnMouseEnter: PropTypes.bool,
    children: PropTypes.node,
    builderBlock: PropTypes.object
}

export const CarouselDefinition = {
    component: CustomCarousel,
    name: 'v1: Carousel',
    canHaveChildren: true,
    childRequirements: {
        message:
            "Children of 'Carousel' must be 'CarouselButton', 'CarouselContentNav', or 'v1: CarouselContent'",
        query: {
            'component.name': {
                $in: ['CarouselButton', 'v1: CarouselContent', 'CarouselContentNav']
            }
        }
    },
    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '80%'
    },
    defaultChildren: [
        defaultPreviousButton,
        defaultCarouselContent,
        defaultNextButton,
        defaultContentNav
    ],
    inputs: [
        {
            name: 'align',
            type: 'string',
            enum: ['start', 'center', 'end'],
            defaultValue: 'start',
            helperText: 'Align the slides relative to the carousel viewport.'
        },
        {
            name: 'loop',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Enables infinite looping.'
        },
        {
            name: 'slidesToScroll',
            type: 'number',
            defaultValue: 1,
            helperText: 'Group slides together.'
        },
        {
            name: 'autoplay',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Automatically advance slides.'
        },
        {
            name: 'autoplayDelay',
            type: 'number',
            defaultValue: 9000,
            helperText: 'Delay between slide changes (ms).'
        },
        {
            name: 'stopOnInteraction',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Stop autoplay after user interaction.'
        },
        {
            name: 'stopOnMouseEnter',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Pause autoplay while hovering.'
        }
    ]
}
